// removed by extract-text-webpack-plugin
module.exports = {"container":"nHvkfKnk9EWJyFZCbaCIs","Icon":"_1HIA-IPpIDt5zKvphMNOgH","Title":"_2C9dAMuBhjiWbua-3Xxpnw"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/DocumentVerify/Main/Verify/Actions/styles.css
// module id = 3007
// module chunks = 0